// extracted by mini-css-extract-plugin
export default {"fiber-one-time-fee":"styles_fiber-one-time-fee__7uYSo"};